module.exports = "/fonts/vendor/boxicons/boxicons.svg?9e2b21b135bc7d4c803f4f6defbdd91e";